import React, { useState } from "react";
import { AddFlex } from "../reusableStyles";
import { Outlet } from "react-router";
import growezyAi from "../ImageAssets/growezyArrow.svg";
import {
  Briefcase,
  ChevronRight,
  HelpCircle,
  Settings,
  User,
} from "lucide-react";

const ChatSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  return (
    <AddFlex height="100vh">
      <div
        className={`bg-transparent text-white transition-all duration-300 ease-in-out flex flex-col ${
          isOpen ? "w-64" : "w-12"
        } relative`}
        style={{ zIndex: "111111" }}
      >
        {/* Toggle Button */}
        <AddFlex
          // onClick={toggleSidebar}
          alignItems="center"
          margin="10px auto 0 auto"
        >
          {isOpen ? (
            <ChevronRight size={20} />
          ) : (
            <div>
              <a href="#" className="flex items-center p-2 rounded-md">
                <img src={growezyAi} style={{ width: "20px" }} />
                {isOpen && <span className="ml-3">Home</span>}
              </a>
            </div>
          )}
        </AddFlex>

        {/* Sidebar Header */}
        {/* <div className="p-4 h-16 flex items-center justify-between border-b border-gray-700">
          {isOpen ? <h2 className="text-xl font-bold">Dashboard</h2> : null}
        </div> */}

        {/* Sidebar Content */}
        <nav className="flex-1 mt-3">
          <ul className="space-y-2 px-2">
            {/* <li>
              <a
                href="#"
                className="flex items-center p-2 rounded-md hover:bg-gray-700"
              >
                <Home size={20} />
                {isOpen && <span className="ml-3">Home</span>}
              </a>
            </li> */}
            <li>
              <a href="#" className="flex items-center p-2 rounded-md">
                <Briefcase size={20} style={{ color: "#004ACE" }} />
                {isOpen && <span className="ml-3">Profile</span>}
              </a>
            </li>
            <li>
              <a href="#" className="flex items-center p-2 rounded-md">
                <Settings size={20} style={{ color: "#004ACE" }} />
                {isOpen && <span className="ml-3">Settings</span>}
              </a>
            </li>
            <li>
              <a href="#" className="flex items-center p-2 rounded-md">
                <HelpCircle size={20} style={{ color: "#004ACE" }} />
                {isOpen && <span className="ml-3">Help</span>}
              </a>
            </li>
          </ul>
        </nav>

        {/* Sidebar Footer */}
        {/* <div className="p-4 border-t border-gray-700">
          {isOpen ? (
            <p className="text-sm text-gray-400">© 2025 Dashboard</p>
          ) : null}
        </div> */}
      </div>
      <Outlet />
    </AddFlex>
  );
};

export default ChatSidebar;
